import { getTitle } from './utils';
import HeadIcon from './head-icon';
import styles from 'styles/LandingLocalitiesList.module.scss';
import { usePageInfo } from 'context/PageInfoContext';

const LocalitiesListHead = () => {
    const { pageInfo } = usePageInfo();

    return (
        <div className={styles.cities_wrapper__title}>
            <HeadIcon template={pageInfo.template_type} />
            <p className={styles.title}>{getTitle(pageInfo)}</p>
        </div>
    );
};

export default LocalitiesListHead;
